import React from 'react';
import { FileText } from 'lucide-react';

const BetListTab = () => {
  return (
    <div className="p-8 text-center">
      <FileText className="w-16 h-16 text-blue-500 mx-auto mb-4" />
      <h3 className="text-xl font-semibold text-gray-800 mb-2">BetList</h3>
      <p className="text-gray-600">Manage and view betting lists.</p>
    </div>
  );
};

export default BetListTab; 